export const RATE = 1;
export const VOLUME = 1;
export const VOICE = '';
